import React from "react";

type ModuleItem = { module_category?: string; moduleWeight?: number | string };

export type ComponentEntry = { key: string; node: React.ReactNode };

/*
	Собираем список компонентов в том порядке, в каком встречаются модули
	На выходе получаем два компонента: чат или дашборд (или один из двух)
	
	available — отображение категории -> ReactNode (например { dashboard: <Dashboard/>, chat: <Chat/> })
	max — максимум возвращаемых компонентов (по умолчанию 2)
*/
export const filterComponents = (
	appModules?: ModuleItem[],
	available: Record<string, React.ReactNode> = {},
	max = 2,
): ComponentEntry[] => {
	const components: ComponentEntry[] = [];
	if (!appModules || appModules.length === 0) return components;

	// Секции не меняют порядок — мы просто фильтруем их по весу.
	// Если moduleWeight === 0 — пропускаем компонент.
	const added = new Set<string>();
	for (const item of appModules) {
		const cat = item.module_category;
		if (!cat) continue;

		// Фильтруем по весу — если есть поле moduleWeight и оно равно 0, то пропускаем
		const weight =
			item.moduleWeight != null ? Number(item.moduleWeight) : undefined;
		if (weight === 0) continue;

		if (available[cat] && !added.has(cat)) {
			components.push({ key: cat, node: available[cat] });
			added.add(cat);
		}
		if (components.length >= max) break;
	}

	return components;
};
